// Dans src/services/dashboardService.js
import api from './api';

// Service pour le tableau de bord
const dashboardService = {
  // Obtenir les statistiques générales
  getStats: async (params = {}) => {
    const response = await api.get('/dashboard/stats', { params });
    return response.data;
  },
  
  // Obtenir les données pour les graphiques
  getChartData: async (params = {}) => {
    const response = await api.get('/dashboard/charts', { params });
    return response.data;
  },

// À ajouter dans votre fichier services/dashboardService.js
getAmountDistribution: async (params) => {
  try {
    const response = await api.get('/dashboard/amount-distribution', { params });
    return response.data;
  } catch (error) {
    console.error('Erreur lors du chargement de la répartition des montants:', error);
    throw error;
  }
}

};

export default dashboardService;